import { useMutation } from 'react-query';
import { MUTATION_KEYS } from 'shared/constants';
import { useUser } from 'shared/hooks';
import { useService } from 'shared/providers';
import { UserActivityEvent } from 'shared/types';

export function useUserActivityEvent() {
  const { wpsEventService, appConfig } = useService();
  const user = useUser();

  const mutation = useMutation<string, Error, UserActivityEvent>(
    request => wpsEventService.logUserEvent(user?.id ?? '', appConfig.appId, request),
    {
      mutationKey: MUTATION_KEYS.userActivityEvent,
      onError: () => {
        console.error('there was a problem capturing user event');
      },
    }
  );

  return mutation;
}
